import './App.css';
import splashScreen from './Instructions.png';
import { products } from './Data';
import style from './style.module.scss';
import React, { useState, useRef, useEffect } from 'react';
import { Canvas } from '@react-three/fiber';
import { Environment, Html, OrbitControls, PerspectiveCamera } from '@react-three/drei';
import Windows from './Components/Class/Windows';
import Dome from './Components/Room/Dome';
import { Light } from './Light';
import { Info } from './Components/Info/Info';
import { Product, TestBox } from './Product';
import { MeshPhysicalMaterial, ReinhardToneMapping } from 'three';
import { EffectComposer, Outline, Bloom } from '@react-three/postprocessing';
import {BlendFunction } from 'postprocessing';
import Parquet from './Components/Class/Parquet';
import WallsFramesGraphic from './Components/Class/WallsFramesGraphic';
import Boards2 from './Components/Class/Boards2';
import Walls2 from './Components/Class/Walls2';
import Plant from './Components/Class/Plant';









function App() {

  const [active, setActive] = useState(true);
  const [infoModel, setInfoModel] = useState(null);
  const [selecedPath, setSelectedPath] = useState(null);
  const [infoPath, setInfoPath] = useState(null);
  const [infoPosition, setInfoPosition] = useState([0, 0, 0]);
  const [position, setPosition] = useState([0, 0, 0]);
  const [textInfo, setTextInfo] = useState('ABC');
  const [material, setMaterial] = useState('');
  const [speed, setSpeed] = useState();
  const [name, setName] = useState('title');
  const [currentRef, setCurrentRef] = useState();
  const [myRef, setMyRef] = useState(null);
  const [iseInstructions, setIsInstructions] = useState(true);

  const b7 = useRef();
  const boxRef = useRef();
  const xRef = useRef();
  const ref = useRef();
  const instructionRef = useRef();


  const openInfo = () => {
    setActive(!active)
  }

  const closeInfo = (e) => {
    setActive(!active)
    setSelectedPath(null)
  }

 
  const clickHandler = (path, infoPath,  position, infoPosition, textInfo, name) => {
    setSelectedPath(infoPath);
    setInfoPosition(infoPosition)
    setPosition(position)
    setInfoPosition(position)
    setName(name)
    setTextInfo(textInfo)
    setSpeed(0.1);
    openInfo('sefewfewf');
  }

  const mat7 = new MeshPhysicalMaterial({
    color: 0xfcba03
  })


  const onColor = false;



  return (
    <div className={style['test']}>
    {iseInstructions &&
      <div>
        <img ref={instructionRef} src={splashScreen}  className={style['istructions-start']}/>
        <h3 className={style['click']} onClick={() => setIsInstructions(false)}></h3>
      </div>
    }
    
    <div className={style['root-container']}>
      <div className={style['canvas-container']}>
        <Canvas className={style['canvi']} shadows dpr={[1, 2]} onClick={() => console.log('Canvas clicking')}>
          <OrbitControls 
              target={[-0.95, 1.5, -4]}
              autoRotate 
              autoRotateSpeed={0} 
              enablePan={false} 
              enableZoom={false} 
              minPolarAngle={Math.PI / 2.5}
              maxPolarAngle={Math.PI / 1.8}
          />
          <PerspectiveCamera makeDefault position={[-0.95, 1.5, -3.5]} fov={60} />    
          {active && products.map(({id, path, infoPath, position, rotation, infoPosition, textInfo, name, geometry, ref7 }, i) => {
            return <Product
            key={id}
            ref={ref7}
            material={onColor && mat7}
            geometry={geometry}
            position={position} 
            rotation={rotation}
            path={path} 
            infoPath={infoPath}
            speed={0}
            name={name}
            textInfo={textInfo}
            onPointerUp={() => clickHandler(path, infoPath, position, infoPosition, textInfo, name) }   
          />
          })}

              <Parquet />
              <Plant />
              <Walls2 />
              <WallsFramesGraphic />
              <Boards2 />
              <Windows />
              <Dome />
              
          {/* <Light intensity={2} position={[-6, 2, -2]} rotation={[Math.PI / 5, 0 ,0]} castShadow={true} penumbra={0.2}/> */}

          <ambientLight intensity={0.2}/>
          <pointLight position={[-6, 3, 1]} distance={4.5} castShadow intensity={0.5} penumbra={0.2} />
          <pointLight position={[-6, 3, -3]} distance={4.5} castShadow intensity={0.5} penumbra={0.2} />
          <pointLight position={[-6, 3, -8]} distance={4.5} castShadow intensity={0.5} penumbra={0.2} />

          <pointLight position={[-1, 3, -1]} distance={4.5} castShadow intensity={0.8} penumbra={0.2}/>
          <pointLight position={[-1, 3, -3]} distance={4.5} castShadow intensity={0.8} penumbra={0.2}/>
          <pointLight position={[-1, 3, -8]} distance={4.5} castShadow intensity={0.8} penumbra={0.2}/>

          <Light intensity={0.5} position={[-12, 12, 0]} rotation={[Math.PI/1.5, 0 ,Math.PI/6]} distance={190} penumbra={1} castShadow />
          <Environment background files={'studio_country_hall_2k2.hdr'}  ToneMapping={ReinhardToneMapping}/>

            {/* <EffectComposer multisampling={10} autoClear={false} >
              <Outline 
                blur={0.2}   
                selection={selected} 
                visibleEdgeColor={'green'} 
                hiddenEdgeColor={'green'} 
                edgeStrength={10} 
                blendFunction={BlendFunction.SCREEN} 
                
            />
            </EffectComposer> */}
        </Canvas>
      </div>

          {/* <p>{textInfo}</p> */}

      {!active && <Info 
        onClickBtn={closeInfo}
        name={name}
        textInfo={textInfo}
        path={selecedPath} 
        position={[0, 0, 0]} 
        fov={200}
        scale={[3, 3, 3]}
        rotation={[0, 0, 0]}
        //[0 ,-0.5, 0.2]
      />}
      
    </div>
    </div>
  );
}

export default App;


